import React from 'react';
import { CandidateRegistrationForm } from '../forms/CandidateRegistrationForm';
type CandidateRegistrationPanelProps = {
  formId?: string;
};
export function CandidateRegistrationPanel({
  formId
}: CandidateRegistrationPanelProps) {
  return <div id="candidate-registration" className="scroll-mt-28 border border-line bg-white p-6 sm:p-10" data-id="element-269" data-mp="lbxoghr1t5ui">
      <h3 className="font-serif text-[1.9rem] font-medium leading-tight text-navy" data-id="element-270" data-mp="qdd948pbdacd">Register your interest</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-muted" data-id="element-271" data-mp="bkjgrmoy0zqa">
        Your details are treated confidentially and used only to consider you for relevant searches.
      </p>
      <div className="mt-8" data-id="element-272" data-mp="2niw9r4zvls4">
        <CandidateRegistrationForm formId={formId} data-id="element-273" data-mp="7ksiyz101jc9" />
      </div>
    </div>;
}